<template>
  <!-- 综合数据2 ---饼状图 -->
  <div class="resultEcharts1">
    <div ref="chartRef" style="width: 300px; height: 280px"></div>
    <div
      class="resultEcharts1_status"
      style="display: flex; gap: 8px; align-items: center"
    >
      <span
        style="
          width: 57px;
          display: inline-flex;
          align-items: center;
          color: #6cc6f3;
          margin-right: 15px;
          font-size: 12px;
        "
      >
        <span
          style="
            display: inline-block;
            width: 14px;
            height: 14px;
            background: #fdc632;
            margin-right: 4px;
          "
        ></span>
        正能量
      </span>
      <span
        style="
        width: 57px;
          display: inline-flex;
          align-items: center;
          color: #6cc6f3;
          margin-right: 15px;
          font-size: 12px;
        "
      >
        <span
          style="
            display: inline-block;
            width: 14px;
            height: 14px;
            background: #1b8afd;
            margin-right: 4px;
          "
        ></span>
        负能量
      </span>
      <span
        style="
         width: 57px;
          display: inline-flex;
          align-items: center;
          color: #6cc6f3;
          margin-right: 15px;
          font-size: 12px;
        "
      >
        <span
          style="
            display: inline-block;
            width: 14px;
            height: 14px;
            background: #63e2dd;
            margin-right: 4px;
          "
        ></span>
        生理量
      </span>
    </div>
  </div>
</template>

<script setup>
import * as echarts from "echarts";
import { ref, reactive, onMounted } from "vue";
let chartInstance;
const chartRef = ref(null);
const option = {
  series: [
    {
      type: "pie",
      radius: "50%",
      data: [
        { value: 335, itemStyle: { color: "#63E2DD" } },
        { value: 580, itemStyle: { color: "#1B8AFD" } },
        { value: 2048, itemStyle: { color: "#FDC632" } },
      ],
      label: {
        show: true, // 显示标签
        position: "inside", // 标签显示在扇形内部
        formatter: "{d}%", // 只显示数值（c代表数值）
        fontSize: 12, // 标签字体大小
        fontWeight: "bold", // 标签字体加粗
        color: "#fff", // 标签字体颜色
      },
      emphasis: {
        itemStyle: {
          shadowBlur: 10,
          shadowOffsetX: 0,
          shadowColor: "rgba(0, 0, 0, 0.5)",
        },
      },
    },
  ],
};

const init = () => {
  chartInstance = echarts.init(chartRef.value);
  option && chartInstance.setOption(option);
};
onMounted(() => {
  init();
});
</script>

<style lang="scss" scoped>
.resultEcharts1 {
  position: relative;
  .resultEcharts1_status {
    position: absolute;
    bottom: 50px;
    left: 60px;
  }
}
</style>
